import { useState, useEffect } from 'react'
import api from 'utils/api'
import get from 'lodash/fp/get'
import getOr from 'lodash/fp/getOr'
import remove from 'lodash/fp/remove'

export default () => {
  const [kids, setKids] = useState([])
  const [error, setError] = useState(false)
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    setFetching(true)
    api(`/parents/kids`)
      .then((response) => {
        setFetching(false)
        setKids(getOr([], 'data.kids', response))
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }, [])

  const addKid = ({ name, balance, avatar }) => {
    setFetching(true)
    api
      .post('/parents/kids', { name, balance, avatar })
      .then((response) => {
        setFetching(false)
        setKids([...kids, get('data.kid', response)])
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }

  const editKid = ({ id, name, balance, avatar }) => {
    setFetching(false)
    api
      .patch(`/parents/kids/${id}`, { name, balance, avatar })
      .then((response) => {
        const updatedKid = get('data.kid', response)
        const updatedKids = remove((kid) => kid.id === id, kids)

        setKids([...updatedKids, updatedKid])
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }

  const removeKid = (id) => {
    setFetching(true)
    api
      .delete(`/parents/kids/${id}`)
      .then(() => {
        setFetching(false)
        setKids(remove((kid) => kid.id === id, kids))
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }

  return {
    data: kids,
    error,
    fetching,
    addKid,
    editKid,
    removeKid,
  }
}
